module.exports = "/images/vendor/flag-icon-css/flags/1x1/do.svg?07d2b1ed2aa93592afc9fb24521267d2";